
<div *ngIf="!loading; else showLoaders">
  <ul class="grid-tabs-wrapper"
    [ngClass]="{
      'grid-tabs-wrapper-interactions': data.length <= 6,
      'grid-tabs-wrapper-elevations': data.length > 6 && data.length <= 8
  }">
    <ng-container *ngFor="let d of data">
      <li 
          pTooltip="{{ d.dispalyName }}"
          tooltipPosition="bottom"
          [ngClass]="d.dispalyName === selectedItem ? 'status-segment-selected' : 'status-segment'"
          (click)="onSelect(d)"> 
          <p class="stage-info">
            <strong>{{ d.count }}</strong>
            {{ d.dispalyName }}
          </p>
        </li>
    </ng-container>
  </ul>
</div>
<ng-template #showLoaders>
  <div style="display: flex; flex-direction: column; ">
    <p-skeleton width="95vw" styleClass="mb-3"></p-skeleton>
    <p-skeleton width="95vw" styleClass="mb-3"></p-skeleton>
  </div>
</ng-template>